import isICode from './node/isICode';
import isIHeading from './node/isIHeading';
import isIQuote from './node/isIQuote';
import isIText from './node/isIText';
export function hasText(node) {
    return isICode(node) || isIHeading(node) || isIQuote(node) || isIText(node);
}
export default hasText;    //# sourceMappingURL=hasText.js.map
